import React from "react";
import NavBar from "../../Layout/Navbar";
// import Section from "./Section";
import HeaderSection from "../../components/HeaderSection";

const Layout1 = () => {
  return (
    <React.Fragment>
      <NavBar isDark={false} />
      {/* import Section */}
      {/* <Section /> */}
      <HeaderSection 
            title='Experts in SAP Business Technology Platform (BTP) and Modern Data Platforms for SAP Customers'
            subtitle='We partner with SAP driven organisations to modernise ERP landscapes, build scalable data platforms, and deliver intelligent cloud native applications across SAP BTP and leading cloud ecosystems.'
            mode='home'
        />      
    </React.Fragment>
  );
};

export default Layout1;
